module.exports = __webpack_public_path__ + "img/plan-logo.53df318a.svg";